<template>
    <div id="form">
        <loading-custom :loading="loading" />
        <div class="card">
            <div class="tab-content">
                <div class="tab-pane active" id="Product">
                    <form @submit.prevent="handleSubmit()">
                        <div class="body">
                            <div class="row clearfix">
                                <div class="col-md-12 col-lg-6">
                                    <div class="form-group">
                                        <label class="tw-ml-2">
                                            ชื่อฟอร์ม
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="ชื่อฟอร์ม"
                                            v-model="form.title"
                                            required
                                        />
                                    </div>
                                </div>
                                <div class="col-md-12 col-lg-6">
                                    <div class="form-group">
                                        <label class="tw-ml-2">
                                            ข้อความแจ้งผู้กรอกฟอร์ม
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="ข้อความแจ้งผู้กรอกฟอร์ม"
                                            v-model="form.message_text"
                                            required
                                        />
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label class="tw-ml-2">
                                            รายละเอียด
                                        </label>
                                        <textarea
                                            class="form-control"
                                            v-model="form.description"
                                            placeholder="รายละเอียด"
                                            cols="30"
                                            rows="10"
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="table-form" class="table-responsive">
                            <table class="table table-hover mb-0 c_list">
                                <thead>
                                    <tr>
                                        <th class="tw-whitespace-nowrap">
                                            ชื่อกล่องข้อความ
                                        </th>
                                        <th class="tw-whitespace-nowrap">
                                            ประเภท
                                        </th>
                                        <th
                                            class="tw-whitespace-nowrap tw-text-center"
                                        >
                                            จำเป็นต้องกรอก
                                        </th>
                                        <th
                                            class="tw-whitespace-nowrap tw-text-center"
                                        >
                                            เปิดใช้งาน
                                        </th>
                                        <th
                                            class="tw-whitespace-nowrap tw-text-right"
                                        >
                                            ACTION
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="form.bodies.length == 0">
                                        <td colspan="5" class="text-center">
                                            กรุณากด + เพื่อสร้างกล่องข้อความ
                                        </td>
                                    </tr>
                                    <tr
                                        class="custom-table"
                                        v-else
                                        v-for="(item, index) in form.bodies"
                                        :key="index"
                                    >
                                        <td class="">
                                            <input
                                                type="text"
                                                class="form-control "
                                                placeholder="กรุณากรอกชื่อฟอร์ม"
                                                v-model="item.input"
                                                required
                                            />
                                        </td>

                                        <td class="">
                                            <select
                                                class="form-control "
                                                v-model="item.type"
                                            >
                                                <option hidden value="">
                                                    โปรดเลือกประเภทกล่องข้อความ
                                                </option>
                                                <option value="text">
                                                    กล่องข้อความ
                                                </option>
                                                <option value="textarea">
                                                    กล่องข้อความขนาดใหญ่
                                                </option>
                                                <option value="list">
                                                    ประเภทตัวเลือก
                                                </option>
                                                <option value="date">
                                                    วันที่
                                                </option>
                                            </select>
                                            <div
                                                class="tw-mt-1 custom-input_tag"
                                                v-if="item.type == 'list'"
                                            >
                                                <input-tag
                                                   :add-tag-on-keys=[13,9]
                                                    v-model="item.list"
                                                    class="form-control"
                                                    placeholder="กรุณาเพิ่มตัวเลือก"
                                                ></input-tag>
                                            </div>
                                        </td>
                                        <td class="tw-text-center ">
                                            <input
                                                type="checkbox"
                                                class="form-control"
                                                v-model="item.required"
                                            />
                                        </td>
                                        <td class="tw-text-center">
                                            <button
                                                @click="
                                                    changeStatus(
                                                        index,
                                                        'status_active',
                                                        form.bodies
                                                    )
                                                "
                                                :class="
                                                    `btn btn-sm ${
                                                        item.status_active
                                                            ? 'btn-success'
                                                            : 'btn-danger'
                                                    } tw-h-full`
                                                "
                                                type="button"
                                            >
                                                {{
                                                    `${
                                                        item.status_active
                                                            ? "ON"
                                                            : "OFF"
                                                    }`
                                                }}
                                            </button>
                                        </td>
                                        <td class="tw-text-right ">
                                            <button
                                                class="btn btn-sm btn-danger tw-h-full"
                                                type="button"
                                                @click="
                                                    deleteRow(
                                                        index,
                                                        form.bodies
                                                    )
                                                "
                                            >
                                                <i class="fa fa-trash"> </i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <button
                            class="btn btn-add_row tw-w-full"
                            type="button"
                            @click="addRow"
                        >
                            <i class="fa fa-plus"> </i>
                        </button>
                        <div id="action-btn" class="body">
                            <div class="tw-w-full text-right">
                                <button class="btn btn-sm btn-success">
                                    บันทึก
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-sm btn-default tw-ml-1"
                                    @click="back()"
                                >
                                    ย้อนกลับ
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BootstrapToggle from "vue-bootstrap-toggle";
export default {
    props: {
        shop: {
            default: "",
            type: String,
            required: true
        },
        is_edit: {
            default: "",
            type: Boolean,
            required: true
        },
        form_data: {
            default: "",
            required: false
        }
    },
    components: { BootstrapToggle },
    data() {
        return {
            loading: false,
            form: {
                bodies: []
            },
            bodiesText: ""
        };
    },
    mounted() {
        this.getDataEdit();
    },
    methods: {
        getDataEdit() {
            if (this.is_edit && this.form_data) {
                this.form = this.form_data;
                this.form.bodies.forEach(element => {
                    element.status_active = element.status_active == 1;
                });
            }
        },
        handleSubmit() {
            this.loading = true;
            if (this.is_edit) {
                this.update();
            } else {
                this.store();
            }
        },

        addRow() {
            this.form.bodies.push({
                input: "",
                type: "text",
                required: true,
                status_active: true,
                list: []
            });
        },
        changeStatus(index, key, data) {
            data[index][key] = !data[index][key];
        },
        deleteRow(index, data) {
            data.splice(index, 1);
        },
        async store() {
            this.loading = true;
            if (this.form.bodies.length > 0) {
                await axios
                    .post(`/backend/s/${this.shop}/forms`, this.form)
                    .then(res => {
                        this.back();
                        this.loading = false;
                    })
                    .catch(err => {
                        this.messageAlert(
                            "error",
                            "Sorry",
                            "กรุณาใส่ข้อมูลให้ครบถ้วน"
                        );
                    });
            } else {
                this.loading = false;
                this.messageAlert(
                    "error",
                    "ขอโทษค่ะ",
                    "กรุณาเพิ่มกล่องข้อความ ก่อนบันทึกข้อมูล"
                );
            }
        },
        async update() {
            this.loading = true;
            if (this.form.bodies.length > 0) {
                await axios
                    .patch(
                        `/backend/s/${this.shop}/forms/${this.form.id}`,
                        this.form
                    )
                    .then(res => {
                        this.back();
                        this.loading = false;
                    })
                    .catch(err => {
                        this.messageAlert(
                            "error",
                            "ขอโทษค่ะ",
                            "กรุณาใส่ข้อมูลให้ครบถ้วนก่อนทำการบันทึกข้อมูล"
                        );
                    });
            } else {
                this.loading = false;
                this.messageAlert(
                    "error",
                    "ขอโทษค่ะ",
                    "กรุณาเพิ่มกล่องข้อความ ก่อนบันทึกข้อมูล"
                );
            }
        },
        back() {
            let url = `/backend/s/${this.shop}/forms`;
            const { redirectUrl } = this.getQuery();
            if (redirectUrl) {
                url = redirectUrl;
            }
            window.location.href = url;
        },
        getQuery() {
            const urlSearchParams = new URLSearchParams(window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());
            return params;
        },
        messageAlert(type, title, text) {
            this.$swal({
                icon: type,
                title: title,
                text: text,
                showConfirmButton: true
            });
        }
    }
};
</script>
<style lang="scss">
.custom-input_tag {
    .form-control {
        padding: 0.2rem 0.75rem !important;
        background-color: var(--card-color) !important;
        border-color: var(--border-color) !important;
        font-size: 14px !important;
    }
    .vue-input-tag-wrapper {
        .input-tag,
        .new-tag {
            margin: 5px;
        }
    }
    .vue-input-tag-wrapper .input-tag .remove {
        color: #000;
    }
    .vue-input-tag-wrapper .input-tag {
        background-color: #fde273;
        border: 1px solid hsl(48, 94%, 66%);
        background: #fde273;
        color: #000;
    }
}
</style>
<style lang="scss" scoped>
#form {
    #action-btn {
        padding: 20px 0 !important;
    }
}
.media {
    @media (min-width: 0px) and (max-width: 992px) {
        width: 100%;
        flex-flow: column;
        flex-direction: column-reverse;
    }
}
.media-left {
    img {
        width: 100%;
        max-width: 200px;
    }
    @media (min-width: 0px) and (max-width: 992px) {
        margin-top: 20px;
    }
}
#table-form {
    table {
        min-width: 600px;
        tr.custom-table {
            td:first-child {
                display: flex;
            }
        }
    }
}
.btn-add_row {
    background: #d3d3d3;
    border: none;
    color: #000;
    height: 40px;
}
</style>
